import type { CategoryTreeNode } from '@/types/product';

/** Validate the identity fields required by tree consumers at the API boundary. */
export function assertCategoryTree(value: unknown): asserts value is CategoryTreeNode[] {
  if (!Array.isArray(value)) throw new TypeError('Category tree must be an array');
  const seen = new Set<string>();
  const active = new WeakSet<object>();
  let count = 0;
  function visit(nodes: unknown[], depth: number): void {
    if (depth > 100) throw new TypeError('Category tree exceeds supported depth');
    for (const raw of nodes) {
      if (++count > 100000) throw new TypeError('Category tree exceeds supported size');
      if (typeof raw !== 'object' || raw === null) throw new TypeError('Invalid category node');
      if (active.has(raw)) throw new TypeError('Category tree contains a cycle');
      if (!('id' in raw) || typeof raw.id !== 'string' || !raw.id) throw new TypeError('Category ID is missing');
      if (!('name' in raw) || typeof raw.name !== 'string') throw new TypeError('Category name is missing');
      if (seen.has(raw.id)) throw new TypeError('Duplicate category ID');
      seen.add(raw.id);
      active.add(raw);
      if ('children' in raw && raw.children !== undefined) {
        if (!Array.isArray(raw.children)) throw new TypeError('Category children must be an array');
        visit(raw.children, depth + 1);
      }
      active.delete(raw);
    }
  }
  visit(value, 0);
}
